<template lang='pug'>
  .new-lottery-n-award
    .title 会员日日有惊喜
    .new-lottery-n-award-container
      //- 奖励金
      AwardBlockNew(
        class="new-award-container"
        :awardList="awardList"
        :rewardTaskGuidanceList="rewardTaskGuidanceList"
        :bountyCountToday="bountyCountToday"
        :bountyCountYesterday="bountyCountYesterday"
        :remainDays="remainDays"
        :remainBountyCount="remainBountyCount"
        :isNewVersion="true"
        :points="points"
        :didSignToday="didSignToday"
        :propVersion="propVersion"
        :vipRecordGuid="vipRecordGuid"
        :waitReceiveBonusNum="waitReceiveBonusNum"
        :mobileCharge="mobileCharge"
        :mobileChargeCoupon="mobileChargeCoupon"
        @refresh="(value)=>passEmit('refresh',value)"
        @click-btn="firstStatus"
      )
      //- 抽奖
      Lottery(
        class="new-lottery-container"
        :moduleData="moduleData"
        :isNewVersion="true"
        :currentOrderOptType="currentOrderOptType"
        @refreshData="(value)=>passEmit('refreshData',value)"
        @clickLockLottery="(value)=>passEmit('clickLockLottery',value)"
      )
</template>

<script>
import Lottery from '@/pages/vip/super/components/lottery.vue';
import AwardBlockNew from './award-block-new.vue';

export default {
  name: 'NewLotteryNAward',
  components: {
    Lottery,
    AwardBlockNew,
  },
  props: {
    moduleData: {
      type: Object,
      default: () => { },
    },
    points: {
      type: String,
      default: '0',
    },
    awardList: {
      type: Array,
      default: () => [],
    },
    rewardTaskGuidanceList: {
      type: Array,
      default: () => [],
    },
    didSignToday: {
      type: Boolean,
      required: true,
    },
    bountyCountToday: {
      type: String,
      default: '',
    },
    bountyCountYesterday: {
      type: String,
      default: '',
    },
    remainDays: {
      type: String,
      default: '',
    },
    remainBountyCount: {
      type: String,
      default: '',
    },
    propVersion: {
      type: String,
      default: '',
    },
    vipRecordGuid: {
      type: String,
      default: '',
    },
    waitReceiveBonusNum: {
      type: Number,
      default: null,
    },
    currentOrderOptType: {
      type: Number,
      default: null,
    },
    mobileCharge: {
      type: Object,
      default: () => {},
    },
    mobileChargeCoupon: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  computed: {},
  mounted() { },
  methods: {
    passEmit(emitName, value) {
      this.$emit(emitName, value);
    },
    firstStatus(val) {
      this.$emit('click-btn', val);
    },
  },
};
</script>
<style lang='less' scoped>
.new-lottery-n-award {
  margin-right: 0.12rem;
  margin-left: 0.12rem;
  padding: 0 0.12rem 0.12rem 0.12rem;
  border-radius: 0.16rem;
  background: rgba(255, 255, 255, 1);
  font-family: PingFangSC, sans-serif;
  position: relative;
  font-weight: 600;
  line-height: 0.22rem;
  overflow: hidden;
  margin-bottom: 0.08rem;

  .title {
    padding: 0.12rem 0 0.08rem 0.03rem;
    font-size: 0.16rem;
    color: rgba(36, 39, 41, 1);
  }

  .new-lottery-n-award-container {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .new-award-container {
    flex: 1;
    max-width: 1.59rem;
    height: 1.49rem;
    margin-right: clamp(0.01rem, 0.05rem, 0.09rem);
  }

  .new-lottery-container {
    height: 1.49rem;
    max-width: 1.59rem;
    flex: 1;
  }
}
</style>
